import { useNavigate } from 'react-router-dom';
import { useStore } from '../../store';
import { Button, OptionCard, OptionCardContent, ProgressBar } from '../../components/ui';
import type { AppearanceAnxiety } from '../../types';

const OPTIONS: { value: AppearanceAnxiety; label: string }[] = [
  { value: 'never', label: 'Never' },
  { value: 'rarely', label: 'Rarely' },
  { value: 'sometimes', label: 'Sometimes' },
  { value: 'often', label: 'Often' },
  { value: 'almost_all_the_time', label: 'Almost all the time' },
];

export function AppearanceAnxietyScreen() {
  const navigate = useNavigate();
  const { onboarding, updateOnboarding, nextStep } = useStore();

  const handleSelect = (value: AppearanceAnxiety) => {
    updateOnboarding({ appearanceAnxiety: value });
  };

  const handleContinue = () => {
    if (onboarding.appearanceAnxiety) {
      nextStep();
      navigate('/onboarding/motivation');
    }
  };

  return (
    <div className="screen-container onboarding-screen">
      <ProgressBar current={8} total={17} className="mb-8" />

      <div className="flex-1 flex flex-col">
        <h1 className="text-3xl font-bold mb-2">Do you worry about your appearance?</h1>
        <p className="text-secondary mb-8">Be honest. This helps us guide you.</p>

        <div className="space-y-3 mb-8">
          {OPTIONS.map(({ value, label }) => (
            <OptionCard
              key={value}
              selected={onboarding.appearanceAnxiety === value}
              onClick={() => handleSelect(value)}
            >
              <OptionCardContent title={label} />
            </OptionCard>
          ))}
        </div>
      </div>

      <Button onClick={handleContinue} disabled={!onboarding.appearanceAnxiety}>
        Continue
      </Button>
    </div>
  );
}
